/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { OfflineDeviceReportMetadata } from "./OfflineDeviceReportMetadata";
import {
    OfflineDeviceReportMetadataFromJSON,
    OfflineDeviceReportMetadataFromJSONTyped,
    OfflineDeviceReportMetadataToJSON,
} from "./OfflineDeviceReportMetadata";
import type { TransactionReportMetadata } from "./TransactionReportMetadata";
import {
    TransactionReportMetadataFromJSON,
    TransactionReportMetadataFromJSONTyped,
    TransactionReportMetadataToJSON,
} from "./TransactionReportMetadata";
import type { Nem12ReportMetadata } from "./Nem12ReportMetadata";
import {
    Nem12ReportMetadataFromJSON,
    Nem12ReportMetadataFromJSONTyped,
    Nem12ReportMetadataToJSON,
} from "./Nem12ReportMetadata";
import type { FaultedDeviceReportMetadata } from "./FaultedDeviceReportMetadata";
import {
    FaultedDeviceReportMetadataFromJSON,
    FaultedDeviceReportMetadataFromJSONTyped,
    FaultedDeviceReportMetadataToJSON,
} from "./FaultedDeviceReportMetadata";
import type { UptimeReportMetadata } from "./UptimeReportMetadata";
import {
    UptimeReportMetadataFromJSON,
    UptimeReportMetadataFromJSONTyped,
    UptimeReportMetadataToJSON,
} from "./UptimeReportMetadata";
import type { VehicleReportMetadata } from "./VehicleReportMetadata";
import {
    VehicleReportMetadataFromJSON,
    VehicleReportMetadataFromJSONTyped,
    VehicleReportMetadataToJSON,
} from "./VehicleReportMetadata";

/**
 *
 * @export
 * @interface WebhookMetadata
 */
export interface WebhookMetadata {
    /**
     *
     * @type {Nem12ReportMetadata}
     * @memberof WebhookMetadata
     */
    nem12ReportMetadata?: Nem12ReportMetadata;
    /**
     *
     * @type {TransactionReportMetadata}
     * @memberof WebhookMetadata
     */
    transactionReportMetadata?: TransactionReportMetadata;
    /**
     *
     * @type {UptimeReportMetadata}
     * @memberof WebhookMetadata
     */
    uptimeReportMetadata?: UptimeReportMetadata;
    /**
     *
     * @type {OfflineDeviceReportMetadata}
     * @memberof WebhookMetadata
     */
    offlineDeviceReportMetadata?: OfflineDeviceReportMetadata;
    /**
     *
     * @type {FaultedDeviceReportMetadata}
     * @memberof WebhookMetadata
     */
    faultedDeviceReportMetadata?: FaultedDeviceReportMetadata;
    /**
     *
     * @type {VehicleReportMetadata}
     * @memberof WebhookMetadata
     */
    vehicleReportMetadata?: VehicleReportMetadata;
}

/**
 * Check if a given object implements the WebhookMetadata interface.
 */
export function instanceOfWebhookMetadata(
    value: object,
): value is WebhookMetadata {
    return true;
}

export function WebhookMetadataFromJSON(json: any): WebhookMetadata {
    return WebhookMetadataFromJSONTyped(json, false);
}

export function WebhookMetadataFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): WebhookMetadata {
    if (json == null) {
        return json;
    }
    return {
        nem12ReportMetadata:
            json["nem12ReportMetadata"] == null
                ? undefined
                : Nem12ReportMetadataFromJSON(json["nem12ReportMetadata"]),
        transactionReportMetadata:
            json["transactionReportMetadata"] == null
                ? undefined
                : TransactionReportMetadataFromJSON(
                      json["transactionReportMetadata"],
                  ),
        uptimeReportMetadata:
            json["uptimeReportMetadata"] == null
                ? undefined
                : UptimeReportMetadataFromJSON(json["uptimeReportMetadata"]),
        offlineDeviceReportMetadata:
            json["offlineDeviceReportMetadata"] == null
                ? undefined
                : OfflineDeviceReportMetadataFromJSON(
                      json["offlineDeviceReportMetadata"],
                  ),
        faultedDeviceReportMetadata:
            json["faultedDeviceReportMetadata"] == null
                ? undefined
                : FaultedDeviceReportMetadataFromJSON(
                      json["faultedDeviceReportMetadata"],
                  ),
        vehicleReportMetadata:
            json["vehicleReportMetadata"] == null
                ? undefined
                : VehicleReportMetadataFromJSON(json["vehicleReportMetadata"]),
    };
}

export function WebhookMetadataToJSON(value?: WebhookMetadata | null): any {
    if (value == null) {
        return value;
    }
    return {
        nem12ReportMetadata: Nem12ReportMetadataToJSON(
            value["nem12ReportMetadata"],
        ),
        transactionReportMetadata: TransactionReportMetadataToJSON(
            value["transactionReportMetadata"],
        ),
        uptimeReportMetadata: UptimeReportMetadataToJSON(
            value["uptimeReportMetadata"],
        ),
        offlineDeviceReportMetadata: OfflineDeviceReportMetadataToJSON(
            value["offlineDeviceReportMetadata"],
        ),
        faultedDeviceReportMetadata: FaultedDeviceReportMetadataToJSON(
            value["faultedDeviceReportMetadata"],
        ),
        vehicleReportMetadata: VehicleReportMetadataToJSON(
            value["vehicleReportMetadata"],
        ),
    };
}
